module.exports = __webpack_public_path__ + "static/media/RPR 1c3.342faee6.jpg";